import { ContactCounselorFormModel } from './../modals/contact_counselor/contact_counselor_form_model';
import { ICommand, IDefineCommand, IDatasource } from 'core-ts-types';

angular.module('capability-ng-global').factory(
  'sendCounselorMessageCommand',
  (defineCommand: IDefineCommand, $http: ng.IHttpService): ICommand => {
    return defineCommand('sendCounselorMessageCommand', function(
      deferred: ng.IDeferred<any>,
      counselorMessage: ContactCounselorFormModel
    ): void {
      $http({
        method: 'POST',
        url: 'contact/counselor/',
        data: counselorMessage
      })
        .then(deferred.resolve)
        .catch(deferred.reject);
    });
  }
);



// WEBPACK FOOTER //
// ./app/lib/global/commands/send_counselor_message_command.ts